let timer;
const waitTime = 800;
const messageInput = document.getElementById('newsletter-email-input');
const registerButton = document.getElementById('newsletter-subscription-button');
const emailFullForm = document.querySelector('input#EMAIL');

if (messageInput) {
    messageInput.addEventListener('keyup', event => {
      clearTimeout(timer);
    
      timer = setTimeout(() => {
        doneTyping(event.target.value);
      }, waitTime);
    });
    
    function doneTyping(value) {
        ValidateEmail(value);
    }
}


// Validation de l'input
function ValidateEmail(input) {

    const validRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    // Ok --> On rend le bouton actif
    if (input.match(validRegex)) {
        registerButton.disabled = false;
        emailFullForm.value = input;
        emailFullForm.placeholder = input;

        if (messageInput.classList.contains('invalidated')) {
            messageInput.classList.remove('invalidated');
        }
        if (!messageInput.classList.contains('validated')) {
            messageInput.classList.add('validated');
            
        }
        registerButton.style.opacity = 1;
        registerButton.style.cursor = 'pointer';
        return true;
    } 
    // K0 --> on rend le bouton inactif
    else {
        registerButton.disabled = true;

        if (messageInput.classList.contains('validated')) {
            messageInput.classList.remove('validated');
        }
        if (!messageInput.classList.contains('invalidated')) {
            messageInput.classList.add('invalidated');
        }

        registerButton.style.opacity = .75;
        return false;
    }
}



function loadScript(FILE_URL, async = true) {
    let scriptEl = document.createElement('script');
    scriptEl.setAttribute("src", FILE_URL);
    scriptEl.setAttribute("type", "text/javascript");
    scriptEl.setAttribute("async", async);

    document.body.appendChild(scriptEl);

    // success event 
    scriptEl.addEventListener("load", () => {
        console.log("File loaded")
    });
    // error event
    scriptEl.addEventListener("error", (ev) => {
        console.log("Error on loading file", ev);
    });
}


const nlmodal = document.querySelector('#newsletterModal');
nlmodal.addEventListener('show.bs.modal', () => {
    loadScript('https://www.google.com/recaptcha/api.js?hl=fr', false);
})

